import { c as _c } from "react/compiler-runtime";
import { css } from '@repo/pandacss/css';
import type { BranchId } from '@/shared/config/funnel/constants';
import type { CardTypeOption } from '../../../model/exploreOtherCardTypes';
const BANNER_HEADING_BY_BRANCH = {
  travel: 'Travel card recommendations',
  cash_back: 'Cash Back card recommendations',
  balance_transfer: 'Balance Transfer card recommendations',
  saving_interest: 'Card recommendations to save on interest',
  building_credit: 'Card recommendations to build credit'
} as const satisfies Record<BranchId, string>;
export function CurrentBranchCopy(t0) {
  const $ = _c(6);
  const {
    option
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = css({
      m: "[0]",
      py: {
        base: "1",
        md: "0"
      },
      pl: {
        base: "[32px]",
        md: "0"
      },
      textStyle: "accent.small",
      letterSpacing: "[0.6px]",
      lineHeight: "[1.5]",
      color: "neutral.darkest",
      textAlign: {
        base: "center",
        md: "left"
      }
    });
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== option.icon) {
    t2 = option.icon && <span aria-hidden="true" className={css({
      display: "inline-block",
      verticalAlign: "middle",
      my: "[-3px]",
      ml: {
        base: "[-32px]",
        md: "0"
      },
      mr: "2",
      "& svg": {
        display: "block",
        width: "[24px]",
        height: "[24px]"
      }
    })} dangerouslySetInnerHTML={{
      __html: option.icon
    }} />;
    $[1] = option.icon;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = BANNER_HEADING_BY_BRANCH[option.branchId];
  let t4;
  if ($[3] !== t2 || $[4] !== t3) {
    t4 = <p className={t1}>{t2}{t3}</p>;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
}